"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aggregationIntervalHelperByValueTypeId = void 0;
const _aggregation_helpers_1 = require("../../_aggregation_helpers");
exports.aggregationIntervalHelperByValueTypeId = {
    evapotranspirationETc: _aggregation_helpers_1.dailyOnlyAggregationIntervalHelper,
    evapotranspirationETo: _aggregation_helpers_1.dailyOnlyAggregationIntervalHelper,
    evapotranspirationKc: _aggregation_helpers_1.dailyOnlyAggregationIntervalHelper,
};
//# sourceMappingURL=evapotranspiration.js.map